// This file is auto-generated by @hey-api/openapi-ts

import type {
  Options as ClientOptions,
  TDataShape,
  Client,
} from '@hey-api/client-fetch'
import type {
  UpdatePrivacyData,
  UpdatePrivacyResponse,
  UpdatePrivacyError,
  GenerateTokenData,
  GenerateTokenResponse,
  GenerateTokenError,
  GetStateData,
  GetStateResponse,
  GetStateError,
  GetBrandControlsData,
  GetBrandControlsResponse,
  GetBrandControlsError,
  CreateControlData,
  CreateControlResponse,
  CreateControlError,
  RemoveControlFromAccountData,
  RemoveControlFromAccountResponse,
  RemoveControlFromAccountError,
  AddControlToAccountData,
  AddControlToAccountResponse,
  AddControlToAccountError,
  GetAccountDetailsData,
  GetAccountDetailsResponse,
  GetAccountDetailsError,
  GetControlData,
  GetControlResponse,
  GetControlError,
  GetAccountDetails1Data,
  GetAccountDetails1Response,
  GetAccountDetails1Error,
  GetAccountControlsHistoryData,
  GetAccountControlsHistoryResponse,
  GetAccountControlsHistoryError,
  GetAccountControlsData,
  GetAccountControlsResponse,
  GetAccountControlsError,
  GetAccountCapabilitiesData,
  GetAccountCapabilitiesResponse,
  GetAccountCapabilitiesError,
  SearchAccountData,
  SearchAccountResponse2,
  SearchAccountError,
} from './types.gen'
import { client as _heyApiClient } from './client.gen'

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = ClientOptions<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>
}

/**
 * Update player's privacy settings
 */
export const updatePrivacy = <ThrowOnError extends boolean = false>(
  options?: Options<UpdatePrivacyData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).put<
    UpdatePrivacyResponse,
    UpdatePrivacyError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/v1/self/privacy',
    ...options,
  })
}

export const generateHelpCenterToken = <ThrowOnError extends boolean = false>(
  options?: Options<GenerateTokenData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    GenerateTokenResponse,
    GenerateTokenError,
    ThrowOnError
  >({
    url: '/v1/helpcenter/token',
    ...options,
  })
}

/**
 * account's active controls state
 */
export const getPlayerAccountState = <ThrowOnError extends boolean = false>(
  options?: Options<GetStateData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetStateResponse,
    GetStateError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/v1/self',
    ...options,
  })
}

/**
 * fetch controls in brand
 */
export const getBrandControls = <ThrowOnError extends boolean = false>(
  options: Options<GetBrandControlsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetBrandControlsResponse,
    GetBrandControlsError,
    ThrowOnError
  >({
    url: '/v1/brands/{brandId}/controls',
    ...options,
  })
}

/**
 * create control in brand
 */
export const createControl = <ThrowOnError extends boolean = false>(
  options: Options<CreateControlData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateControlResponse,
    CreateControlError,
    ThrowOnError
  >({
    url: '/v1/brands/{brandId}/controls',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Remove controls from an account
 */
export const removeControlFromAccount = <ThrowOnError extends boolean = false>(
  options: Options<RemoveControlFromAccountData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    RemoveControlFromAccountResponse,
    RemoveControlFromAccountError,
    ThrowOnError
  >({
    url: '/v1/brands/{brandId}/accounts/{accountId}/controls/remove',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Add controls to an account
 */
export const addControlToAccount = <ThrowOnError extends boolean = false>(
  options: Options<AddControlToAccountData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    AddControlToAccountResponse,
    AddControlToAccountError,
    ThrowOnError
  >({
    url: '/v1/brands/{brandId}/accounts/{accountId}/controls/add',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * fetch account details
 */
export const getAccountDetails = <ThrowOnError extends boolean = false>(
  options: Options<GetAccountDetailsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetAccountDetailsResponse,
    GetAccountDetailsError,
    ThrowOnError
  >({
    url: '/v2/brands/{brandId}/accounts/{accountId}',
    ...options,
  })
}

/**
 * fetch control config in brand
 */
export const getControl = <ThrowOnError extends boolean = false>(
  options: Options<GetControlData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetControlResponse,
    GetControlError,
    ThrowOnError
  >({
    url: '/v1/brands/{brandId}/controls/{controlId}',
    ...options,
  })
}

/**
 * fetch account details
 */
export const getAccountDetails1 = <ThrowOnError extends boolean = false>(
  options: Options<GetAccountDetails1Data, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetAccountDetails1Response,
    GetAccountDetails1Error,
    ThrowOnError
  >({
    url: '/v1/brands/{brandId}/accounts/{accountId}',
    ...options,
  })
}

/**
 * fetch controls history on an account
 */
export const getAccountControlsHistory = <ThrowOnError extends boolean = false>(
  options: Options<GetAccountControlsHistoryData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetAccountControlsHistoryResponse,
    GetAccountControlsHistoryError,
    ThrowOnError
  >({
    url: '/v1/brands/{brandId}/accounts/{accountId}/controls/history',
    ...options,
  })
}

/**
 * fetch controls on an account
 */
export const getAccountControls = <ThrowOnError extends boolean = false>(
  options: Options<GetAccountControlsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetAccountControlsResponse,
    GetAccountControlsError,
    ThrowOnError
  >({
    url: '/v1/brands/{brandId}/accounts/{accountId}/controls',
    ...options,
  })
}

/**
 * fetch capabilities on an account
 */
export const getAccountCapabilities = <ThrowOnError extends boolean = false>(
  options: Options<GetAccountCapabilitiesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetAccountCapabilitiesResponse,
    GetAccountCapabilitiesError,
    ThrowOnError
  >({
    url: '/v1/brands/{brandId}/accounts/{accountId}/capabilities',
    ...options,
  })
}

/**
 * Search for accounts details
 * Either accountId or email can be provided, but not both.
 */
export const searchAccount = <ThrowOnError extends boolean = false>(
  options?: Options<SearchAccountData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    SearchAccountResponse2,
    SearchAccountError,
    ThrowOnError
  >({
    url: '/v1/accounts/search',
    ...options,
  })
}
